// extracted by mini-css-extract-plugin
module.exports = {"--grid-sm-breakpoint":"480px","--grid-md-breakpoint":"800px","--grid-lg-breakpoint":"1024px","--grid-xl-breakpoint":"1130px"};